import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://easyenjaz.com/api' 
  : 'https://localhost:7122';

// Generic headers for non-file requests (e.g., GET, DELETE)
const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
};

// Headers for file uploads (e.g., POST, PUT with FormData)
const getFileUploadHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };
};

// Helper function to log FormData entries (for debugging)
//export const logFormData = (formData) => {
  //console.log('FormData contents:');
  //for (let [key, value] of formData.entries()) {
  //  console.log(key, value);
  //}
//};

// Create a new applicant
export const createApplicant = (formData) => {
  //logFormData(formData); // Debugging helper
  return axios.post(`${API_BASE_URL}/Applicants`, formData, getFileUploadHeader());
};

// Update an existing applicant
export const updateApplicant = (id, formData) => {
  //logFormData(formData); // Debugging helper
  return axios.put(`${API_BASE_URL}/Applicants/${id}`, formData, getFileUploadHeader());
};

// Fetch an applicant by ID
export const getApplicantById = (id) => {
  return axios.get(`${API_BASE_URL}/Applicants/${id}`, getAuthHeader());
};

// Fetch all applicants
export const getApplicants = () => {
  return axios.get(`${API_BASE_URL}/Applicants`, getAuthHeader());
};

// Delete an applicant
export const deleteApplicant = (id) => {
  return axios.delete(`${API_BASE_URL}/Applicants/${id}`, getAuthHeader());
};

// Upload file endpoint
export const uploadFile = (file, fileType, applicantId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileType', fileType);
  formData.append('applicantId', applicantId);
  
  return axios.post(`${API_BASE_URL}/Applicants/upload-file`, formData, getFileUploadHeader());
};

// Get file URL endpoint
export const getFileUrl = (fileKey) => {
  return axios.get(`${API_BASE_URL}/Applicants/file-url/${encodeURIComponent(fileKey)}`, getAuthHeader());
};